import { breakpoints, fontFamilies } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { colors } from "../../../utils/colors";

export const Wrapper = styled(Link)`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    color: white;
    background-color: ${colors.brandDark};
    height: 95px;
    padding: 16px;

    border-radius: 12px;
    box-shadow: 0 5px 10px ${transparentize(0.8, "black")};

    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    font-family: ${fontFamilies.heading} !important;
    text-decoration: none;

    transition: 200ms ease all;

    [data-whatintent="mouse"] &:hover {
        transform: translateY(-5px);
        box-shadow: 0 5px 15px ${transparentize(0.7, "black")};
    }

    ${breakpoints.large} {
        height: 140px;
        font-size: 24px;
        padding: 24px;
        padding-right: 48px;
    }
`;

type StylerProps = {
    theme: "dark" | "mid";
};

export const Styler = styled.div<StylerProps>`
    ${Wrapper} {
        ${({ theme }) => {
            switch (theme) {
                case "dark":
                    return css`
                        background-color: ${colors.brandDark};
                    `;
                case "mid":
                    return css`
                        background-color: ${colors.brandMid};
                    `;
                default:
                    return null;
            }
        }}
    }
`;
